<footer class="premium-footer position-relative overflow-hidden">
  <div class="footer-overlay position-absolute w-100 h-100 top-0 start-0 z-0"></div>

  <div class="container-fluid px-4 px-lg-5 pt-5 pb-4 position-relative z-1">
    <div class="row g-4 mb-4">
      <!-- Brand & About -->
      <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
        <a href="/" class="footer-brand d-inline-flex align-items-center gap-2 mb-3 text-decoration-none" routerLink="/">
          <img src="../../../assets/img/logo001.png" alt="BtechMart Logo" class="footer-logo">
        </a>
        <p class="footer-desc pe-lg-4">
          Btechmart understands the importance of a reliable and efficient platform to find jobs, business partners, properties, and construction services. We offer a comprehensive platform for all these services in one place.
        </p>

        <!-- Support Card -->
        <div class="footer-contact-card">
          <div class="support-icon-circle">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.57a1 1 0 01-.24 1.02l-2.21 2.2z"/>
            </svg>
          </div>
          <div class="support-text-wrap">
            <span class="support-label">Talk to our Support</span>
            <a href="tel:+916386884363" class="support-phone">+91 6386884363</a>
          </div>
        </div>
      </div>

      <!-- Quick Links -->
      <div class="col-lg-2 col-md-6 col-6 mb-4 mb-lg-0">
        <h3 class="footer-heading">Quick Links</h3>
        <ul class="footer-links">
          <li>
            <a href="/articles/list" routerLink="/articles/list">
              <svg class="link-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
              <span>Blogs</span>
            </a>
          </li>
          <li>
            <a href="/contact-us" routerLink="/contact-us">
              <svg class="link-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
              <span>Contact Us</span>
            </a>
          </li>
          <li>
            <a href="/feedback" routerLink="/feedback">
              <svg class="link-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
              <span>Feedback</span>
            </a>
          </li>
          <li>
            <a href="/complain" routerLink="/complain">
              <svg class="link-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
              <span>Complaint</span>
            </a>
          </li>
          <li>
            <a href="/privacy-policy" routerLink="/privacy-policy">
              <svg class="link-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
              <span>Privacy Policy</span>
            </a>
          </li>
          <li>
            <a href="/terms-of-use" routerLink="/terms-of-use">
              <svg class="link-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
              <span>Terms & Condition</span>
            </a>
          </li>
        </ul>
      </div>

      <!-- Categories -->
      <div class="col-lg-2 col-md-6 col-6 mb-4 mb-lg-0">
        <h3 class="footer-heading">Top Categories</h3>
        <ul class="footer-links">
          <li>
            <a href="/construction" routerLink="/construction">
              <svg class="link-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
              <span>Construction</span>
            </a>
          </li>
          <li>
            <a href="/interior" routerLink="/interior">
              <svg class="link-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
              <span>Interior</span>
            </a>
          </li>
          <li>
            <a href="/b2b" routerLink="/b2b">
              <svg class="link-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
              <span>B2B Marketplace</span>
            </a>
          </li>
          <li>
            <a href="https://property.btechmart.in/" target="_blank" rel="noopener noreferrer">
              <svg class="link-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
              <span>Real Estate</span>
            </a>
          </li>
          <li>
            <a href="/leads" routerLink="/leads">
              <svg class="link-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
              <span>Insurance</span>
            </a>
          </li>
          <li>
            <a href="/leads" routerLink="/leads">
              <svg class="link-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
              <span>Loan</span>
            </a>
          </li>
          <li>
            <a href="https://btechcars.com/" target="_blank" rel="noopener noreferrer">
              <svg class="link-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
              <span>Cars</span>
            </a>
          </li>
          <li>
            <a href="/leads" routerLink="/leads">
              <svg class="link-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
              <span>Jobs</span>
            </a>
          </li>
        </ul>
      </div>

      <!-- Newsletter & Social -->
      <div class="col-lg-4 col-md-6">
        <h3 class="footer-heading">Newsletter</h3>
        <p class="newsletter-desc">Subscribe to our newsletter for the latest updates, exclusive offers, and business insights.</p>

        <form class="footer-newsletter">
          <input
            type="email"
            class="newsletter-input"
            placeholder="Enter your email address..."
            aria-label="Enter email address for newsletter"
            required
          />
          <button type="submit" class="newsletter-btn" aria-label="Subscribe to newsletter">
            <span>Subscribe</span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="22" y1="2" x2="11" y2="13"></line>
              <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
            </svg>
          </button>
        </form>

        <h4 class="social-heading">Connect With Us</h4>
        <div class="footer-social">
          <!-- Facebook -->
          <a href="https://www.facebook.com/profile.php?id=61568582751285" target="_blank" rel="noopener noreferrer" class="social-btn facebook" aria-label="Facebook">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          </a>

          <!-- LinkedIn -->
          <a href="https://www.linkedin.com/in/kaushik-sahu-b0532b320/" target="_blank" rel="noopener noreferrer" class="social-btn linkedin" aria-label="LinkedIn">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
            </svg>
          </a>

          <!-- X / Twitter -->
          <a href="https://twitter.com/btechmart" target="_blank" rel="noopener noreferrer" class="social-btn twitter" aria-label="Twitter">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
          </a>

          <!-- Instagram -->
          <a href="https://www.instagram.com/btechmart/" target="_blank" rel="noopener noreferrer" class="social-btn instagram" aria-label="Instagram">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
          </a>

          <!-- YouTube -->
          <a href="https://www.youtube.com/@btechmart" target="_blank" rel="noopener noreferrer" class="social-btn youtube" aria-label="YouTube">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- Bottom Bar -->
  <div class="footer-bottom position-relative z-1">
    <div class="container-fluid px-4 px-lg-5">
      <div class="row align-items-center">
        <div class="col-md-6 text-center text-md-start mb-2 mb-md-0">
          <p class="copyright-text">
            © 2026 <strong>BtechMart</strong>. All Rights Reserved.
          </p>
        </div>
        <div class="col-md-6 text-center text-md-end">
          <div class="bottom-links">
            <a href="/privacy-policy" routerLink="/privacy-policy">Privacy Policy</a>
            <span class="divider">|</span>
            <a href="/terms-of-use" routerLink="/terms-of-use">Terms of Service</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>